'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { isSecondDecemberEvent } from '../_utils/isSecondDecemberEvent';
import { INVITE_EVENT_CONFIG } from '../constants';
interface RecentWinnerData {
  maskedNickname: string;
  rewardPoint: number;
}
const {
  transitionDurationSeconds,
  easingCurve,
  carouselRotationIntervalMs
} = INVITE_EVENT_CONFIG.animation;
export const RealtimeNotification = () => {
  const $ = _c(19);
  const [currentIndex, setCurrentIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event-history/reward/recent"]({
        query: {
          eventCodeList: isSecondDecemberEvent() ? ["INVITEE_ON_JOIN_2025_12_2ND", "INVITER_ON_DONATION_2025_12_2ND"] : ["INVITEE_ON_JOIN_2025_12_1ND", "INVITER_ON_DONATION_2025_12_1ND"],
          size: 3
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: recentWinnersData
  } = useSuspenseQuery(t0);
  const hasWinnersData = (recentWinnersData?.length ?? 0) > 0;
  let t1;
  let t2;
  if ($[1] !== hasWinnersData || $[2] !== recentWinnersData.length) {
    t1 = () => {
      if (!hasWinnersData) {
        return;
      }
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % recentWinnersData.length);
      }, carouselRotationIntervalMs);
      return () => clearInterval(interval);
    };
    t2 = [recentWinnersData.length, hasWinnersData];
    $[1] = hasWinnersData;
    $[2] = recentWinnersData.length;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!hasWinnersData) {
    return null;
  }
  let t3;
  if ($[5] !== recentWinnersData) {
    t3 = index => {
      const winner = recentWinnersData[index % recentWinnersData.length];
      return `${winner.maskedNickname}님이\n${winner.rewardPoint.toLocaleString()}원을 받았어요!`;
    };
    $[5] = recentWinnersData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getMessage = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M0 12V7.2C0 5.8 0.3 4.5 0.9 3.3C1.5 2.1 2.4 1.1 3.6 0.3L5.4 2.1C4.6 2.7 4 3.3 3.6 4C3.2 4.7 3 5.4 3 6.2H5.4V12H0ZM8.4 12V7.2C8.4 5.8 8.7 4.5 9.3 3.3C9.9 2.1 10.8 1.1 12 0.3L13.8 2.1C13 2.7 12.4 3.3 12 4C11.6 4.7 11.4 5.4 11.4 6.2H13.8V12H8.4Z" fill="#f6e0cf" /></svg>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mask: "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
      WebkitMask: "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      y: 0
    };
    t7 = {
      y: -64
    };
    t8 = {
      duration: transitionDurationSeconds,
      ease: easingCurve
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [0, 1, 2];
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== currentIndex || $[14] !== getMessage) {
    t10 = t9.map(offset => <motion.p key={offset} initial={{
      opacity: offset === 0 ? 1 : 0.2
    }} animate={{
      opacity: offset === 1 ? 1 : 0.2
    }} transition={{
      duration: transitionDurationSeconds,
      ease: "easeOut"
    }} className="whitespace-pre-line text-center font-700 text-[#f6e0cf] typo-body1">{getMessage(currentIndex + offset)}</motion.p>);
    $[13] = currentIndex;
    $[14] = getMessage;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== currentIndex || $[17] !== t10) {
    t11 = <div className="flex w-full flex-col items-center">{t4}<div className="relative h-146 w-full overflow-hidden" style={t5}><motion.div key={currentIndex} initial={t6} animate={t7} transition={t8} className="flex flex-col gap-12">{t10}</motion.div></div></div>;
    $[16] = currentIndex;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.contents ?? [] as RecentWinnerData[];
}